import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CmsService } from '@spartacus/core';
@Component({
    selector: 'app-landingpage',
    templateUrl: './landingpage.component.html',
    styleUrl: './landingpage.component.scss',
    standalone: false
})
export class LandingpageComponent {
  constructor(public PageParagraphComponent : CmsComponentData<any>,private contentservice:ContentService,private cd:ChangeDetectorRef,private userInfoService: UserInfoService,private router: Router,private activatedRoute: ActivatedRoute,private cmsService:CmsService){}
  listarray:string='';
  startlandingcontent: Observable<any> = this.PageParagraphComponent.data$;
  startdata:any;
  landing:any;
  landingapi:any;
  seasonModal:boolean= false;
  @ViewChild('seasonModal')
  seasonModalTemplate: any;
  seasonclick:string=''
  seasonclicked: string='';
  enablePage: any;
  isLoading: boolean = false;
  inseason: string = '';
  preseason: string = '';
  orderseason:any;
  rbapermission:any;
  //inseasonFormattedText: string = '2024/2025';
  //preseasonFormattedText: string = '2025/2026';
  creditBlockPopUp : Observable<any> = this.cmsService.getComponentData('creditBlockPopup');
  ngOnInit() {
    this.startlandingcontent.subscribe(res => {
      this.startdata=res;
      const list=this.startdata.ourCommitmentsList;
      this.listarray=list.split(" ").join(",");
   
    });
  
     
        this.contentservice.startorder_Landing(this.listarray).subscribe((data:any) => {
          this.landing=data;
          this.cd.detectChanges();
        });
      this.contentservice.startapi().subscribe(data => {
      this.landingapi=data;
      this.inseason=this.landingapi?.currentInSeason;
      this.preseason=this.landingapi?.prePreSeason;
      
      this.cd.detectChanges();
      });
      if(!this.router.url.includes('editOrder')) {
      const obj = {
        showLandingPage: true,
        showLocationPage: false,
        showProductPage: false,
        showReviewPage: false
      }
      this.userInfoService.setEnablePage(obj);
      }
      this.userInfoService.getEnablePage().subscribe((data:any) => {
        this.enablePage = data;
      })


      this.activatedRoute.queryParams.subscribe(data => {   
   
          
          this.orderseason=data
          if(this.orderseason.season) {
       this.continue(this.orderseason.season)
        }
        });
        
    
  }
  openModal(seasonvalue:string){
  this.seasonModal=true;
  this.seasonclick=seasonvalue;
  }
  continue(value:string){
    this.userInfoService.sendstartorderseason(value);
    const body=<HTMLElement>document.querySelector("body");
    if(value==this.inseason){
        body.classList.add("inseasonenabled");
    }else{
      body.classList.remove("inseasonenabled");
   }
   if(value==this.preseason){
    body.classList.add("prepreseason");
}else{
  body.classList.remove("prepreseason");
}
    const obj = {
      showLandingPage: false,
      showLocationPage: true,
      showProductPage: false,
      showReviewPage: false
    }
    this.userInfoService.setEnablePage(obj);
    this.userInfoService.setInPlaceOrder(true);
  }
  selectlocationseason(){
    this.userInfoService.getstartorderseason().subscribe(value => {
      this.seasonclicked = value;
    });
  }
  goToDashboard(){
    this.seasonModal = false;
    this.cd.detectChanges();  
    this.router.navigate(['/my-account']);
  }
}

